import * as React from 'react'

interface LogoProps extends React.SVGProps<SVGSVGElement> {
  color?: string
  size?: 'sm' | 'md'
}

export const ChaineLogo = React.forwardRef<SVGSVGElement, LogoProps>(({ size = 'sm', color, ...props }, ref) => {
  // Default colors using Tailwind's dark mode detection
  const logoColor = color || 'currentColor' // This will respect dark/light mode automatically
  const dimensions = size === 'sm' ? '24' : '40'
  const sizeClass = size === 'sm' ? 'w-6 h-6' : 'w-10 h-10'

  return (
    <div className={`${sizeClass} text-gray-800 dark:text-white`}>
      <svg
        width={dimensions}
        height={dimensions}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <g clipPath="url(#clip0_2110_2015)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.1623 6.3522C0.178812 7.04085 -0.0602053 8.39638 0.628441 9.37987L6.11483 17.2152C6.80347 18.1987 8.15901 18.4377 9.1425 17.7491L10.6478 16.6951L7.58553 12.3218C6.89689 11.3383 7.1359 9.98274 8.11939 9.29409L11.6003 6.85676L9.17612 3.39472C8.48747 2.41123 7.13194 2.17222 6.14845 2.86086L1.1623 6.3522Z"
            fill={logoColor}
          />
          <rect
            x="8.07587"
            y="10.9758"
            width="10.4348"
            height="13.913"
            rx="2.17391"
            transform="rotate(-35 8.07587 10.9758)"
            fill={logoColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_2110_2015">
            <rect width="24" height="24" fill={logoColor} />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
})
